import {cleanFields} from '../../../utilities/helper/cleanFields';
import request from '../../axios';

const PatchFarmAdvertisement = async (
  payload: IFarmAdvertisementPayload,
  guid?: string,
) => {
  const newPayload = {
    ad_type: payload.ad_type,
    srs_type: payload.srs_type?.type,
    sub_input: payload.sub_input?.guid,
    title: payload.title,
    description: payload?.description || null,
    il_type: payload?.type,
    ad_price: payload.price_on_call ? null : payload.ad_price,
    price_on_call: payload?.price_on_call || false,
    price_unit: payload.price_unit?.value || undefined,
    farm: payload?.farm?.guid,
    existing: payload.existing,
    water_system: payload?.water_system?.guid || null,
    has_discount: payload?.has_discount || null,
    discount_amount: payload?.discount_amount || null,
    profile_type: 'supplier',
    attributes: payload.attributes || null,
    location: `POINT (${payload.location?.lng} ${payload.location?.lat})`,
    irrigation_volume_unit: payload?.irrigation_volume_unit?.guid || null,
    irrigation_volume_time: payload?.irrigation_volume_time?.guid || null,
    irrigation_volume: payload?.irrigation_volume || null,
    is_change_title: payload?.is_change_title || false,
    images_id: payload?.images?.map(item => item).toString() || null,
    main_image_id: payload?.main_image || null,
    filter: 'advertisement',
    only_massage_buyer: payload.only_massage_buyer || false,
  };

  // ✅ specify which fields to check/remove if null
  const cleanedPayload = cleanFields(newPayload, [
    'discount_amount',
    'has_discount',
    'attributes',
  ]);

  const response = await request.patch(`api/v2/store/advertisement/${guid}`, {
    ...cleanedPayload,
  });

  return response.data;
};

export default PatchFarmAdvertisement;
